/**
 * C1: the closed Sarah disc can be minimized to an edge tab. The choice holds
 * for 7 days (localStorage) and for the session (sessionStorage). Storage can
 * throw (Safari private mode), so every access falls back to memory.
 */
export const SARAH_LAUNCHER_MIN_KEY = 'rr_sarah_launcher_min'
export const SARAH_LAUNCHER_MIN_TTL_MS = 7 * 24 * 60 * 60 * 1000

let memoryMinimized: number | null = null

type Store = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>

function safeLocal(): Store | null {
  try {
    return typeof localStorage === 'undefined' ? null : localStorage
  } catch {
    return null
  }
}

function safeSession(): Store | null {
  try {
    return typeof sessionStorage === 'undefined' ? null : sessionStorage
  } catch {
    return null
  }
}

export function readLauncherMinimized(now: number = Date.now()): boolean {
  try {
    if (safeSession()?.getItem(SARAH_LAUNCHER_MIN_KEY) === '1') return true
  } catch {
    /* fall through */
  }
  let at: number | null = null
  let fromStorage = false
  try {
    const local = safeLocal()
    const raw = local?.getItem(SARAH_LAUNCHER_MIN_KEY)
    fromStorage = !!local
    if (raw) {
      const parsed = JSON.parse(raw) as { at?: unknown }
      if (typeof parsed?.at === 'number') at = parsed.at
    }
  } catch {
    at = null
  }
  // Memory is only the fallback when storage cannot be read at all.
  if (!fromStorage) at = memoryMinimized
  return at != null && now - at < SARAH_LAUNCHER_MIN_TTL_MS
}

export function writeLauncherMinimized(now: number = Date.now()): void {
  memoryMinimized = now
  try {
    safeLocal()?.setItem(SARAH_LAUNCHER_MIN_KEY, JSON.stringify({ at: now, v: 1 }))
  } catch {
    /* memory fallback */
  }
  try {
    safeSession()?.setItem(SARAH_LAUNCHER_MIN_KEY, '1')
  } catch {
    /* memory fallback */
  }
}

export function clearLauncherMinimized(): void {
  memoryMinimized = null
  try {
    safeLocal()?.removeItem(SARAH_LAUNCHER_MIN_KEY)
  } catch {
    /* ignore */
  }
  try {
    safeSession()?.removeItem(SARAH_LAUNCHER_MIN_KEY)
  } catch {
    /* ignore */
  }
}
